<button
  *ngIf="!linkRouter"
  class="navigation-tab-bar-conversion-button"
  type="button"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<a
  *ngIf="linkRouter"
  [routerLink]="linkRouter"
  class="navigation-tab-bar-conversion-button"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<ng-template #content>
  <vtmn-play-icon
    class="navigation-tab-bar-conversion-button__icon"
    [name]="iconName"
    [ariaLabel]="ariaLabel"
  ></vtmn-play-icon>
</ng-template>
